// import React from "react";
// import { Table, Button, Form, Badge, Spinner, InputGroup } from "react-bootstrap";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./AdminReviewFormsPage.css";
// import useReviewForms, { getReviewStatusInfo } from "../../hooks/useReviewForms";
// import FormAssignmentSummaryCards from "../../components/forms/FormAssignmentSummaryCards";

// const TONE_TO_BADGE = { danger: "danger", secondary: "secondary", info: "info", success: "success", light: "light" };

// // Admin's OWN page for "Review Forms" -- a management-style single table
// // (no status tabs, a labeled filter row, Bootstrap Badges) using the
// // shared `unit-*` classes that inherit Admin's teal theme ambiently.
// // All data/business logic comes from the SAME useReviewForms() hook
// // RoleReviewFormsPage.jsx uses.
// export default function AdminReviewFormsPage() {
//   const {
//     rows, total, loading, busyId,
//     statusTab, setStatusTab, formTypeFilter, setFormTypeFilter, projectFilter, setProjectFilter,
//     search, setSearch, formTypes, projects,
//     currentPage, setCurrentPage, totalPages,
//     hasActiveFilters, clearFilters,
//     startOrContinue, viewSubmitted, fetchAssignments,
//   } = useReviewForms();

//   return (
//     <div className="unit-page admin-form-page reviewforms-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Form Management</div>
//           <h2>Review Forms</h2>
//           <p>Forms assigned to you for completion and review.</p>
//         </div>
//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchAssignments} disabled={loading}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>
//         </div>
//       </div>

//       <FormAssignmentSummaryCards />

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <h5 className="mb-0">
//             <i className="fa-solid fa-clipboard-check reviewforms-list-icon" aria-hidden="true"></i>
//             Assigned Forms
//           </h5>
//         </div>

//         <div className="unit-filter-row admin-assignments-filter-row">
//           <Form.Group>
//             <Form.Label className="small mb-0">Search</Form.Label>
//             <InputGroup>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search..."
//                 aria-label="Search assigned forms"
//                 value={search}
//                 onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }}
//               />
//             </InputGroup>
//           </Form.Group>
//           <Form.Group>
//             <Form.Label className="small mb-0">Status</Form.Label>
//             <Form.Select value={statusTab} onChange={(e) => { setCurrentPage(1); setStatusTab(e.target.value); }}>
//               <option value="">All</option>
//               <option value="pending">Pending</option>
//               <option value="in_progress">In Progress</option>
//               <option value="submitted">Submitted</option>
//               <option value="overdue">Overdue</option>
//             </Form.Select>
//           </Form.Group>
//           <Form.Group>
//             <Form.Label className="small mb-0">Form Type</Form.Label>
//             <Form.Select value={formTypeFilter} onChange={(e) => { setCurrentPage(1); setFormTypeFilter(e.target.value); }}>
//               <option value="">All</option>
//               {formTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//             </Form.Select>
//           </Form.Group>
//           <Form.Group>
//             <Form.Label className="small mb-0">Project</Form.Label>
//             <Form.Select value={projectFilter} onChange={(e) => { setCurrentPage(1); setProjectFilter(e.target.value); }}>
//               <option value="">All</option>
//               {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//             </Form.Select>
//           </Form.Group>
//           {hasActiveFilters && <Button className="unit-clear-filters-btn" onClick={clearFilters}>Clear</Button>}
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader"><Spinner animation="border" /><p>Loading assigned forms...</p></div>
//           ) : rows.length === 0 ? (
//             <div className="unit-empty">
//               <div className="unit-empty-icon">
//                 <i className="fa-solid fa-inbox" aria-hidden="true"></i>
//               </div>
//               <h5>No assigned forms found</h5>
//               <p>{hasActiveFilters || statusTab ? "Try another filter, or clear filters." : "Nothing is currently assigned to you."}</p>
//             </div>
//           ) : (
//             <Table responsive bordered hover size="sm" className="unit-table">
//               <thead>
//                 <tr>
//                   <th>Form / Assignment</th>
//                   <th>Assigned By</th>
//                   <th>Scope</th>
//                   <th>Due</th>
//                   <th>Status</th>
//                   <th className="text-end">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((row) => {
//                   const info = getReviewStatusInfo(row);
//                   return (
//                     <tr key={row.assignment_user_id}>
//                       <td>
//                         <div><strong>{row.assignment_title}</strong> {!!row.is_mandatory && <Badge bg="warning" text="dark">Mandatory</Badge>}</div>
//                         <div className="small text-muted">{row.form_name} · {row.form_type_name}</div>
//                       </td>
//                       <td className="small">{row.assigned_by_name || "—"}</td>
//                       <td className="small text-muted">{row.project_name || "—"}{row.project_module_name ? ` / ${row.project_module_name}` : ""}</td>
//                       <td className={`small ${row.is_overdue ? "text-danger fw-bold" : ""}`}>{row.effective_due_at ? new Date(row.effective_due_at).toLocaleDateString() : "—"}</td>
//                       <td><Badge bg={TONE_TO_BADGE[info.tone]}>{info.label}</Badge></td>
//                       <td className="text-end">
//                         {(row.my_status === "ASSIGNED" || row.my_status === "IN_PROGRESS") && row.assignment_status === "ACTIVE" && (
//                           <Button size="sm" variant="primary" disabled={busyId === row.assignment_user_id} onClick={() => startOrContinue(row)}>
//                             <i className={`fa-solid ${row.my_status === "IN_PROGRESS" ? "fa-forward" : "fa-play"}`} aria-hidden="true"></i>
//                             {row.my_status === "IN_PROGRESS" ? "Continue" : "Start"}
//                           </Button>
//                         )}
//                         {row.latest_submission_id && (row.my_status === "SUBMITTED" || row.my_status === "COMPLETED") && (
//                           <Button size="sm" variant="outline-secondary" onClick={() => viewSubmitted(row)}>
//                             <i className="fa-solid fa-eye" aria-hidden="true"></i>
//                             View
//                           </Button>
//                         )}
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong></div>
//           {totalPages > 1 && (
//             <div className="unit-pagination d-flex gap-2">
//               <Button size="sm" variant="outline-secondary" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
//                 <i className="fa-solid fa-chevron-left" aria-hidden="true"></i>
//                 Prev
//               </Button>
//               <span className="align-self-center small">{currentPage} / {totalPages}</span>
//               <Button size="sm" variant="outline-secondary" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>
//                 Next
//                 <i className="fa-solid fa-chevron-right" aria-hidden="true"></i>
//               </Button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }








import React from "react";
import { Button, Form, Badge, Spinner, InputGroup } from "react-bootstrap";


import "./AdminReviewFormsPage.css";

import useReviewForms, {
  getReviewStatusInfo,
  getRecipientAction,
  RECIPIENT_ACTION_REASON_LABELS,
} from "../../hooks/useReviewForms";

import FormAssignmentSummaryCards from "../../components/forms/FormAssignmentSummaryCards";

const TONE_TO_BADGE = {
  danger: "danger",
  secondary: "secondary",
  info: "info",
  success: "success",
  light: "light",
  warning: "warning",
};

// Admin's OWN page for "Review Forms" -- a management-style single table
// (no status tabs, a labeled filter row, Bootstrap Badges) using the
// shared `unit-*` classes that inherit Admin's teal theme ambiently.
// All data/business logic comes from the SAME useReviewForms() hook
// RoleReviewFormsPage.jsx uses.
// KPI reduction (Forms Workspace polish pass): "To Fill" only cares about
// the current user's own assigned-forms progress -- the assignee group
// FormAssignmentSummaryCards already fetches.
const TO_FILL_PRIMARY_KEYS = [
  "assignee.reviewFormsPending",
  "assignee.reviewFormsInProgress",
  "assignee.reviewFormsSubmitted",
  "assignee.reviewFormsOverdue",
];

export default function AdminReviewFormsPage({ embedded = false } = {}) {
  const {
    rows,
    total,
    loading,
    busyId,

    statusTab,
    setStatusTab,
    formTypeFilter,
    setFormTypeFilter,
    projectFilter,
    setProjectFilter,

    search,
    setSearch,
    formTypes,
    projects,

    currentPage,
    setCurrentPage,
    totalPages,

    hasActiveFilters,
    clearFilters,

    startOrContinue,
    viewSubmitted,
    fetchAssignments,
  } = useReviewForms();

  return (
    <div className={`unit-page admin-form-page reviewforms-mgmt-theme ${embedded ? "fa-embedded" : ""}`}>

      <div className="unit-header">
        {!embedded && (
          <div>
            <div className="unit-page-label">Form Management</div>
            <h2>Review Forms</h2>
            <p>Forms assigned to you for completion and review.</p>
          </div>
        )}
        <div className="unit-header-actions">
          <Button
            className="unit-btn unit-btn-light"
            onClick={fetchAssignments}
            disabled={loading}
          >
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>
        </div>
      </div>

      <FormAssignmentSummaryCards primaryKeys={embedded ? TO_FILL_PRIMARY_KEYS : undefined} />

      <div className="unit-card reviewforms-card">
        <div className="unit-toolbar reviewforms-toolbar">
          <div className="reviewforms-section-title">
            <div className="reviewforms-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="reviewforms-section-copy">
              <h5>Assigned Forms</h5>
              <p>
                Search assigned forms, filter by status, type or project, and
                continue or review submissions.
              </p>
            </div>
          </div>

          <div className="admin-assignments-filter-row reviewforms-filters-row">
            <Form.Group className="reviewforms-filter-group reviewforms-search-group">
              <Form.Label>Search</Form.Label>

              <InputGroup className="reviewforms-search">
                <InputGroup.Text aria-hidden="true">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </InputGroup.Text>

                <Form.Control
                  placeholder="Search..."
                  aria-label="Search assigned forms"
                  value={search}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearch(e.target.value);
                  }}
                />

                {search && (
                  <Button
                    className="reviewforms-clear-search"
                    onClick={() => {
                      setCurrentPage(1);
                      setSearch("");
                    }}
                    title="Clear search"
                    aria-label="Clear search"
                  >
                    <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                  </Button>
                )}
              </InputGroup>
            </Form.Group>

            <Form.Group className="reviewforms-filter-group">
              <Form.Label>Status</Form.Label>

              <div className="reviewforms-select-wrap">
                <i
                  className="fa-solid fa-circle-check reviewforms-select-icon"
                  aria-hidden="true"
                ></i>

                <Form.Select
                  value={statusTab}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setStatusTab(e.target.value);
                  }}
                >
                  <option value="">All</option>
                  <option value="pending">Pending</option>
                  <option value="in_progress">In Progress</option>
                  <option value="submitted">Submitted</option>
                  <option value="overdue">Overdue</option>
                </Form.Select>
              </div>
            </Form.Group>

            <Form.Group className="reviewforms-filter-group">
              <Form.Label>Form Type</Form.Label>

              <div className="reviewforms-select-wrap">
                <i
                  className="fa-solid fa-shapes reviewforms-select-icon"
                  aria-hidden="true"
                ></i>

                <Form.Select
                  value={formTypeFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setFormTypeFilter(e.target.value);
                  }}
                >
                  <option value="">All</option>

                  {formTypes.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>

            <Form.Group className="reviewforms-filter-group">
              <Form.Label>Project</Form.Label>

              <div className="reviewforms-select-wrap">
                <i
                  className="fa-solid fa-diagram-project reviewforms-select-icon"
                  aria-hidden="true"
                ></i>

                <Form.Select
                  value={projectFilter}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setProjectFilter(e.target.value);
                  }}
                >
                  <option value="">All</option>

                  {projects.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>

            {hasActiveFilters && (
              <Button
                className="reviewforms-clear-filters-btn"
                onClick={clearFilters}
              >
                <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                Clear
              </Button>
            )}
          </div>
        </div>

        <div className="rfl-card-list">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading assigned forms...</p>
            </div>
          ) : rows.length === 0 ? (
            <div className="unit-empty">
              <div className="unit-empty-icon">
                <i className="fa-solid fa-inbox" aria-hidden="true"></i>
              </div>

              <h5>No assigned forms found</h5>

              <p>
                {hasActiveFilters || statusTab
                  ? "Try another filter, or clear filters."
                  : "Nothing is currently assigned to you."}
              </p>

              {(hasActiveFilters || statusTab) && (
                <Button
                  className="unit-btn unit-btn-light"
                  onClick={clearFilters}
                >
                  <i
                    className="fa-solid fa-rotate-left"
                    aria-hidden="true"
                  ></i>
                  Clear Filters
                </Button>
              )}
            </div>
          ) : (
            rows.map((row) => {
              const info = getReviewStatusInfo(row);
              const action = getRecipientAction(row);
              return (
                <div key={row.assignment_user_id} className="rfl-card">
                  <div className="rfl-card-main">
                    <div className="rfl-card-title-row">
                      <strong>{row.assignment_title}</strong>
                      <Badge bg={TONE_TO_BADGE[info.tone]} className="rfl-status-badge">{info.label}</Badge>
                      {!!row.is_mandatory && <Badge bg="danger" className="rfl-mandatory-badge">Mandatory</Badge>}
                    </div>
                    <div className="rfl-card-meta">
                      <span><i className="fa-regular fa-file-lines" aria-hidden="true"></i> {row.form_name}{row.form_type_name ? ` · ${row.form_type_name}` : ""}</span>
                      <span><i className="fa-regular fa-user" aria-hidden="true"></i> By {row.assigned_by_name || "—"}</span>
                      <span className={row.is_overdue ? "rfl-overdue" : ""}>
                        <i className="fa-regular fa-calendar" aria-hidden="true"></i> Due {row.effective_due_at ? new Date(row.effective_due_at).toLocaleDateString() : "—"}
                      </span>
                      {(row.project_name) && <span><i className="fa-regular fa-folder" aria-hidden="true"></i> {row.project_name}{row.project_module_name ? ` / ${row.project_module_name}` : ""}</span>}
                    </div>
                  </div>
                  <div className="rfl-card-action">
                    {(action.type === "start" || action.type === "continue") && (
                      <Button className="unit-btn unit-btn-primary" disabled={busyId === row.assignment_user_id} onClick={() => startOrContinue(row)}>
                        {action.needsChanges ? "Correct Response" : action.type === "continue" ? "Continue" : "Start Form"}
                        <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                      </Button>
                    )}
                    {action.type === "view" && (
                      <Button className="unit-btn unit-btn-light" onClick={() => viewSubmitted(row)}>
                        View Submission
                      </Button>
                    )}
                    {action.type === "none" && (
                      <span className="rfl-action-empty">
                        {RECIPIENT_ACTION_REASON_LABELS[action.reason] || "—"}
                      </span>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{rows.length}</strong> of <strong>{total}</strong>
          </div>

          {totalPages > 1 && (
            <div className="unit-pagination reviewforms-pagination">
              <Button
                className="reviewforms-page-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
                title="Previous page"
                aria-label="Previous page"
              >
                <i
                  className="fa-solid fa-chevron-left"
                  aria-hidden="true"
                ></i>
              </Button>

              <span className="reviewforms-page-number">
                {currentPage} / {totalPages}
              </span>

              <Button
                className="reviewforms-page-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
                title="Next page"
                aria-label="Next page"
              >
                <i
                  className="fa-solid fa-chevron-right"
                  aria-hidden="true"
                ></i>
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
